import {h} from 'ui/Framework';

export default h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '48',
  height: '40',
  viewBox: '0 0 48 40'
}, [
  h('path', {
    d: 'M47 8h-5V5c0-.5-.5-1-1-1H16V1c0-.5-.5-1-1-1H1C.5 0 0 .5 0 1v33c0 3.3 2.7 6 6 6h35c3.9 0 7-3.1 7-7V9c0-.5-.5-1-1-1zM10 9v25c0 2.2-1.8 4-4 4s-4-1.8-4-4V2h12v3c0 .5.5 1 1 1h25v2H11c-.5 0-1 .5-1 1zm36 24c0 2.8-2.2 5-5 5H10.5c1-1.1 1.5-2.5 1.5-4V10h34v23z',
    fill: '#0eb87f'
  }),
  h('path', {
    d: 'M40 6v2H11c-.5 0-1 .5-1 1v25c0 2.2-1.8 4-4 4s-4-1.8-4-4V2h12v3c0 .5.5 1 1 1h25z',
    fill: '#c0f2d6'
  })
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/space.es6.js